
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Show loading spinner while checking authentication state
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-interview-blue"></div>
      </div>
    );
  }

  if (user) {
    // If a returnUrl is present (e.g. members-only learn article), honor it.
    // Fallback to dashboard and guard against external redirects.
    const returnUrl = location.search ? new URLSearchParams(location.search).get('returnUrl') : null;
    const redirectTo = returnUrl && returnUrl.startsWith('/') ? returnUrl : '/dashboard';
    return <Navigate to={redirectTo} replace />;
  }

  // User is not authenticated, render the public component
  return <>{children}</>;
};

export default PublicRoute;
